exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table .td-actions button.btn {\n  margin-right: 5px;\n}", ""]);

// exports
